import styled from 'styled-components';

const InputContainer = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.spacing.S12};
  grid-template-columns: 106px 1fr;
`;

export { InputContainer };
